import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d0c4df3e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c4df3e')) {
      api.createRecord('d0c4df3e', component.options)
    } else {
      api.reload('d0c4df3e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d0c4df3e&", function () {
      api.rerender('d0c4df3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G99XWqO4snmF/JS/comp/childrenage.vue"
export default component.exports